import { BasePanel } from '../../Panel/BasePanel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SmartPropertiesBatchPanelBody } from './SmartPropertiesBatchPanelBody';
import { SmartPropertiesBatchPanelFooter } from './SmartPropertiesBatchPanelFooter';
import { SmartPropertiesBatchPanelProvider } from './SmartPropertiesBatchPanelProvider';
import { SmartPropertiesBatchContextProvider } from './useSmartPropertiesBatch/SmartPropertiesBatchContextProvider';
import { CRMSearchProvider } from '../../CRMSearchProvider';
import { PANEL_INLINE_SIZE } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SmartPropertiesBatchPanel(props) {
  return /*#__PURE__*/_jsx(SmartPropertiesBatchPanelProvider, {
    children: /*#__PURE__*/_jsx(SmartPropertiesBatchPanelInternal, Object.assign({}, props))
  });
}
export function SmartPropertiesBatchPanelInternal({
  onClose,
  onLogging,
  objectTypeId,
  selectionIds,
  selectionCrmSearchQuery,
  selectionMethod,
  onEnrich
}) {
  function handleClose(__enriched) {
    onClose === null || onClose === void 0 || onClose();
  }
  return /*#__PURE__*/_jsx(SmartPropertiesBatchContextProvider, {
    objectTypeId: objectTypeId,
    onClose: handleClose,
    onEnrich: onEnrich,
    onLogging: onLogging,
    selectionCrmSearchQuery: selectionCrmSearchQuery,
    selectionIds: selectionIds,
    selectionMethod: selectionMethod,
    children: /*#__PURE__*/_jsx(CRMSearchProvider, {
      query: selectionCrmSearchQuery,
      selectionIds: selectionIds,
      selectionMethod: selectionMethod,
      children: /*#__PURE__*/_jsxs(BasePanel, {
        inlineSize: PANEL_INLINE_SIZE,
        isOpen: true,
        onClose: onClose,
        children: [/*#__PURE__*/_jsx(BasePanel.Header, {
          children: /*#__PURE__*/_jsx(BasePanel.Heading, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "smartProperties.panel.title"
            })
          })
        }), /*#__PURE__*/_jsx(SmartPropertiesBatchPanelBody, {}), /*#__PURE__*/_jsx(SmartPropertiesBatchPanelFooter, {})]
      })
    })
  });
}